import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { Dialog, IconButton, Fade } from '@material-ui/core';
import { CloseOutlined } from '@ant-design/icons';
import MenuBlock from '../MenuBlock';
import MenuProduct from '../MenuProduct';
import { leasing, dailyrental, buy } from '../../../utils/ProductMenu';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Fade ref={ref} {...props} timeout={{ enter: 500, exit: 500 }} />; //<Slide direction="down" ref={ref} {...props} />;
});

const MenuType = Object.freeze({
    EASY_LEASE: 'lease',
    DAILY_RENTAL: 'dailyrental',
    BUY: 'buy',
});

const getMenu = (type) => {
    switch (type) {
        case MenuType.EASY_LEASE:
            return leasing;
        case MenuType.DAILY_RENTAL:
            return dailyrental;
        case MenuType.BUY:
            return buy;
        default:
            break;
    }
};

const getDialogStyle = (type) => {
    switch (type) {
        case MenuType.EASY_LEASE:
            return 'dialog-content';
        case MenuType.DAILY_RENTAL:
            return 'dialog-content-daily-rental';
        case MenuType.BUY:
            return 'dialog-content-buy';
        default:
            return 'dialog-content';
    }
};

const MegaMenu = (props) => {
    const { type, open } = props;
    const populateMenu = (data) => {
        return (
            <Row justify="center" key="1">
                {data.map((value, key) => (
                    <Fragment key={key}>
                        <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 12 }}
                            xl={{ span: 12 }}
                            xxl={{ span: 12 }}
                            key={key}
                        >
                            {value.product !== undefined && (
                                <MenuProduct
                                    is_main_product={value.product.is_main_product}
                                    logo={value.product.logo}
                                    name={value.product.title}
                                    url1={value.product.url1}
                                    url2={value.product.url2}
                                    description={value.product.descripton}
                                    enableButton={value.product.browse}
                                    closeMenu={props.closeDialog}
                                />
                            )}
                        </Col>
                        <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 12 }}
                            xl={{ span: 12 }}
                            xxl={{ span: 12 }}
                            key={key}
                        >
                            {value.menu.map((data, key) => {
                                return <MenuBlock data={data} key={key} closeMenu={props.closeDialog} />;
                            })}
                        </Col>
                    </Fragment>
                ))}
            </Row>
        );
    };

    return (
        <Dialog
            test_id="mega-menu"
            className="dialog"
            open={open}
            fullScreen
            TransitionComponent={Transition}
            transitionDuration={{ enter: 500, exit: 500 }}
        >
            <div className="header">
                {/* <Logo /> */}
                <IconButton className="close-button" edge="end" onClick={() => props.closeDialog(false)}>
                    <CloseOutlined />
                </IconButton>
            </div>
            <div className={getDialogStyle(type)}>{populateMenu(getMenu(type))}</div>
        </Dialog>
    );
};

MegaMenu.propTypes = {
    type: PropTypes.oneOf(['lease', 'dailyrental', 'buy']).isRequired,
    open: PropTypes.bool.isRequired,
    closeDialog: PropTypes.func.isRequired,
};
MegaMenu.defaultProps = {
    type: 'lease',
    open: false,
};

export default MegaMenu;
